import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaArrowLeft, FaCheck, FaExclamationTriangle } from 'react-icons/fa';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);

    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
      // Here you would typically make an actual API call to your backend
      console.log('Password reset email would be sent to:', email);
    }, 2000);
  };

  if (isSubmitted) {
    return (
      <div className="forgot-password-page">
        <div className="forgot-password-page-header">
          <div className="forgot-password-container">
            <h1 className="forgot-password-page-title">
              <FaCheck />
              Email Sent Successfully
            </h1>
            <p className="forgot-password-page-subtitle">Check your inbox for reset instructions</p>
          </div>
        </div>

        <div className="forgot-password-section">
          <div className="forgot-password-container">
            <div className="forgot-password-container">
              <div className="success-card">
                <div className="success-icon">
                  <FaCheck />
                </div>
                <h2>Reset Email Sent!</h2>
                <p>
                  We've sent a password reset link to <strong>{email}</strong>
                </p>
                <p>
                  Please check your email and click the link to reset your password. 
                  If you don't see the email, check your spam folder.
                </p>
                <div className="success-actions">
                  <Link to="/login" className="forgot-password-btn forgot-password-btn-primary">
                    <FaArrowLeft />
                    Back to Login
                  </Link>
                  <button 
                    className="forgot-password-btn forgot-password-btn-outline" 
                    onClick={() => setIsSubmitted(false)}
                  >
                    Send Another Email
                  </button>
                </div>
                <p className="help-text">
                  Didn't receive the email? Contact support at 
                  <a href="mailto:support@iiitk.ac.in"> support@iiitk.ac.in</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-page-header">
        <div className="forgot-password-container">
          <h1 className="forgot-password-page-title">
            <FaEnvelope />
            Reset Password
          </h1>
          <p className="forgot-password-page-subtitle">Enter your email to receive reset instructions</p>
        </div>
      </div>

      <div className="forgot-password-section">
        <div className="forgot-password-container">
          <div className="forgot-password-container">
            <div className="forgot-password-card">
              <div className="card-header">
                <h2>Forgot Your Password?</h2>
                <p>No worries! Enter your email address and we'll send you a link to reset your password.</p>
              </div>

              <form className="forgot-password-form" onSubmit={handleSubmit}>
                {error && (
                  <div className="error-message">
                    <FaExclamationTriangle />
                    <span>{error}</span>
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <div className="input-group">
                    <FaEnvelope className="input-icon" />
                    <input
                      type="email"
                      id="email"
                      placeholder="Enter your registered email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={isLoading}
                      required
                    />
                  </div>
                </div>

                <button 
                  type="submit" 
                  className={`forgot-password-btn forgot-password-btn-primary forgot-password-btn-full ${isLoading ? 'loading' : ''}`}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <div className="spinner"></div>
                      Sending Reset Link...
                    </>
                  ) : (
                    <>
                      <FaEnvelope />
                      Send Reset Link
                    </>
                  )}
                </button>
              </form>

              <div className="card-footer">
                <p>Remember your password?</p>
                <Link to="/login" className="back-to-login">
                  <FaArrowLeft />
                  Back to Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;